module.exports = __webpack_public_path__ + "static/media/Email campaign-rafiki.bed62d3d.svg";